import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ShellComponent } from '@app/shell/shell.component';
import { HomeComponent } from '@app/home/home.component';
import { MyAgentsRouteGuard } from '@app/my-agents/my-agents-route-guard';
import { QuickCartRouteGuard } from '@app/quick-cart/quick-cart-route-guard';

import { GeneralErrorComponent } from '@app/shared/components/error-pages/general-error/general-error.component';
import { NotFoundComponent } from '@app/shared/components/error-pages/not-found/not-found.component';
import { ServiceRequestErrorComponent } from '@app/shared/components/error-pages/service-request-error/service-request-error.component';
import { OnlineTermsComponent } from '@app/pages/online-terms/online-terms.component';
import { LegalUseGuard } from '@app/services/legal-use.guard';
import { OrderHistoryRouteGuard } from '@app/order-history/order-history-route-guard';
import { SamplingSuppliesRouteGuard } from './sampling-supplies/sampling-supplies-route-guard';
import { OrderCheckoutRouteGuard } from './order-checkout/order-checkout-route-guard';

export const appRoutes: Routes = [
    {
        path: 'connected-apps',
        loadChildren: () => import('./connected-apps/connected-apps.module').then(m => m.ConnectedAppsModule)
    },
    {
        path: '',
        component: ShellComponent,
        canActivateChild: [LegalUseGuard],
        children: [
            { path: '', component: HomeComponent, data: { pageHeader: 'Analytical Testing Services', animationData: 'home' } },
            {
                path: 'sampling-supplies',
                loadChildren: () => import('./sampling-supplies/sampling-supplies.module').then(m => m.SamplingSuppliesModule),
                canActivate: [SamplingSuppliesRouteGuard]
            },
            {
                path: 'my-agents',
                loadChildren: () => import('./my-agents/my-agents.module').then(m => m.MyAgentsModule),
                canActivate: [MyAgentsRouteGuard]
            },
            {
                path: 'checkout',
                loadChildren: () => import('./order-checkout/order-checkout.module').then(m => m.OrderCheckoutModule),
                canActivate: [OrderCheckoutRouteGuard]
            },
            {
                path: 'quick-cart',
                loadChildren: () => import('./quick-cart/quick-cart.module').then(m => m.QuickCartModule),
                canActivate: [QuickCartRouteGuard]
            },
            {
                path: 'profile',
                loadChildren: () => import('./contact-profile/contact-profile.module').then(m => m.ContactProfileModule)
            },
            {
                path: 'payments',
                loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsModule)
            },

            {
                path: 'orders/history/old',
                loadChildren: () => import('./order-history/historical-order-history.module').then(m => m.HistoricalOrderHistoryModule),
                canLoad: [OrderHistoryRouteGuard],
                canActivate: [OrderHistoryRouteGuard]
            },
            {
                path: 'orders/history',
                loadChildren: () => import('./order-history/current-order-history.module').then(m => m.CurrentOrderHistoryModule),
                canLoad: [OrderHistoryRouteGuard],
                canActivate: [OrderHistoryRouteGuard]
            },
            {
                path: 'pages/online-terms-and-conditions',
                component: OnlineTermsComponent,
                data: { pageHeader: 'Online Terms & Conditions', animationData: 'online-terms' }
            },
            {
                path: 'lab-orders',
                loadChildren: () => import('./lab-orders/lab-orders.module').then(m => m.LabOrdersModule),
                data: { pageHeader: 'Order Laboratory Tests', animationData: 'lab-orders' }
            },
            {
                path: 'lab-tests',
                loadChildren: () => import('./lab-orders/lab-orders.module').then(m => m.LabOrdersModule),
                data: { pageHeader: 'Order Laboratory Tests', animationData: 'lab-orders' }
            },
            { path: 'error', component: ServiceRequestErrorComponent, data: { pageHeader: 'Error' } },
            { path: '404', component: NotFoundComponent, data: { pageHeader: '404 - Page Not Found' } },
            { path: '400', component: GeneralErrorComponent, data: { pageHeader: 'Error' } }
        ]
    },
    { path: 'catalogue/category', redirectTo: '/sampling-supplies' },
    { path: 'substance', redirectTo: '/lab-tests' },
    { path: '**', redirectTo: '/404', pathMatch: 'full' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: PreloadAllModules,
            scrollPositionRestoration: 'top',
            paramsInheritanceStrategy: 'always'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

